function initAudelvynProducts() {
  document.querySelectorAll('[data-av-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const photo = root.querySelector('[data-av-photo]');
    root.querySelector('[data-av-zoom]')?.addEventListener('click', event => {
      const on = photo.classList.toggle('av-is-zoomed');
      event.currentTarget.setAttribute('aria-pressed', String(on));
    });
    root.querySelector('[data-av-model]')?.addEventListener('change', event => {
      if (event.target.value) window.location.assign(event.target.value);
    });
    root.querySelectorAll('[data-av-image]').forEach(button => button.addEventListener('click', () => {
      const img = photo.querySelector('img');
      img.removeAttribute('srcset');
      img.src = button.dataset.avImage;
    }));
    const form = root.querySelector('.av-sale-form');
    form?.addEventListener('submit', async event => {
      const button = event.submitter;
      if (!button?.matches('[data-av-buy-now]')) return;
      event.preventDefault();
      if (!form.reportValidity() || form.dataset.pending === 'true') return;
      const error = root.querySelector('[data-av-checkout-error]');
      const controls = [...form.querySelectorAll('button')];
      const disabledStates = controls.map(control => control.disabled);
      const id = form.querySelector('[name="id"]').value;
      const quantity = Number(form.querySelector('[name="quantity"]').value);
      error.hidden = true;
      form.dataset.pending = 'true';
      button.setAttribute('aria-busy', 'true');
      controls.forEach(control => { control.disabled = true; });
      try {
        const response = await fetch(button.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : button.dataset.error);
        const checkout = document.createElement('form');
        checkout.method = 'post';
        checkout.action = button.dataset.cartUrl;
        const proceed = document.createElement('input');
        proceed.type = 'hidden';
        proceed.name = 'checkout';
        proceed.value = 'Checkout';
        checkout.appendChild(proceed);
        document.body.appendChild(checkout);
        checkout.submit();
      } catch (failure) {
        error.textContent = failure.message || button.dataset.error;
        error.hidden = false;
        button.removeAttribute('aria-busy');
        controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
        form.dataset.pending = 'false';
      }
    });
  });
}
initAudelvynProducts();
document.addEventListener('shopify:section:load', initAudelvynProducts);
